/* ==========================================================================
   Design System
   Breakpoint JavaScript variables.
   All values are pixel based.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.scss as well.
   ========================================================================== */

export const varsBreakpoints = {
  bpXS: {
    min: 0,
    max: 600,
  },
  bpSM: {
    min: 601,
    max: 900,
  },
  bpMED: {
    min: 901,
    max: 1020,
  },
  bpLG: {
    min: 1021,
    max: 1200,
  },
  bpXL: {
    min: 1201,
  },
};
